<template>
  <div>
    <titulo-topo-da-pagina titulo="DRP - Configuração do Robô de Separação Automatica" />

    <v-card flat>
      <v-tabs centered>
        <v-tab @click="tab = 1">
          <v-icon left>mdi-clipboard-list</v-icon>
          Lista de Pedidos
        </v-tab>
        <v-tab @click="tab = 1">
          <v-icon left>mdi-truck-outline</v-icon>
          Transportes
        </v-tab>
        <v-tab @click="tab = 2">
          <v-icon left>mdi-home-variant</v-icon>
          Grupo de Separação
        </v-tab>

        <v-tab @click="tab = 3">
          <v-icon left>mdi-email-edit</v-icon>
          Workflow
        </v-tab>

        <v-tab @click="tab = 4">
          <v-icon left>mdi-home-group</v-icon>
          Filiais de Separação
        </v-tab>
        <v-tab @click="tab = 5">
          <v-icon left>mdi-calendar-outline</v-icon>
          Calendario de Separação
        </v-tab>
        <v-tab @click="tab = 6">
          <v-icon left>mdi-map-marker-path</v-icon>
          MAPA DE SEPARAÇÃO
        </v-tab>

        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <lista-de-pedidos />
            </v-card-text>
          </v-card>
        </v-tab-item>
          <v-tab-item class="ma-0">
            <v-card flat>
              <v-card-text class="pa-0">
                <Transporte />
              </v-card-text>
            </v-card>
          </v-tab-item>
        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <GrupoSeparacao />
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <WorkflowEmail />
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <GrupoSeparacaoFilial :atualizar="tab" />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <CalendarioSeparacao :atualizar="tab" />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <MapaDeSeparacao class="px-2" />
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>

<script>
import Transporte from "./Transporte";
import GrupoSeparacao from "@/components/drp/configDrpAutomatizado/GrupoSeparacao/Index.vue";
import GrupoSeparacaoFilial from "./GrupoSeparacaoFilial";
import CalendarioSeparacao from "./CalendarioSeparacao";
// import MapaDeSeparacao from "./MapaDeSeparacao";
import MapaDeSeparacao from "./MapaDeSeparacao/Index.vue";
import TituloTopoDaPagina from "../../utils/TituloTopoDaPagina";
import ListaDePedidos from "./PedidosDeSeparacao/ListaDePedidos";
import WorkflowEmail from "@/components/drp/configDrpAutomatizado/WorkflowEmail/Index.vue";

export default {
  name: "DRPConfiguracao",
  components: {
    ListaDePedidos,
    TituloTopoDaPagina,
    Transporte,
    GrupoSeparacao,
    GrupoSeparacaoFilial,
    CalendarioSeparacao,
    MapaDeSeparacao,
    WorkflowEmail,
  },
  data: () => ({
    tab: null,
  })
};
</script>
